<template>
  <v-container grid-list-sm text-xs-left>
    <v-form ref="form">
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="name"
            label="Startup Name"
            :rules="rules.name"
            required
            :counter="50"
            @input="$v.name.$touch()"
            @blur="sanitize($event, 'name')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="country"
            :items="countries"
            label="Country"
            menu-props="auto, overflowY"
            required
            item-text="country"
            item-value="country"
            return-object
            @change="$v.country.$touch()"
            @blur="$v.country.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 v-if="country === 'Italy'" class="pa-3">
          <v-select
            v-model="region"
            :items="regions"
            label="Region"
            menu-props="auto, overflowY"
            required
            item-text="region"
            item-value="region"
            return-object
            @change="$v.region.$touch()"
            @blur="$v.region.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 v-else class="pa-3">
          <v-text-field
            v-model="city"
            label="City"
            required
            :rules="rules.city"
            :counter="100"
            @input="$v.city.$touch()"
            @blur="sanitize($event, 'city')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="area"
            :items="Object.keys(areas)"
            label="Area"
            @change="$v.area.$touch()"
            @blur="$v.area.$touch()"
            class="text_wrapper"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="verticalSolution"
            :items="areas[area]"
            label="Vertical solution"
            @change="$v.verticalSolution.$touch()"
            @blur="$v.verticalSolution.$touch()"
            class="text_wrapper"
            no-data-text="No data available. First select the area"
          >
            <template slot="item" slot-scope="data">
              {{ data.item }}
              <v-spacer></v-spacer>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="ideaState"
            :items="ideaStates"
            label="Idea State"
            menu-props="auto, overflowY"
            item-text="ideaState"
            item-value="ideaState"
            return-object
            @change="$v.ideaState.$touch()"
            @blur="$v.ideaState.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="contactName"
            label="Contact Name"
            :counter="100"
            :rules="rules.contactName"
            @input="$v.contactName.$touch()"
            @blur="sanitize($event, 'contactName')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="contactDetails"
            label="Email Addresses (separate emails by , or ; or / )"
            :rules="rules.email"
            :counter="500"
            @input="$v.contactDetails.$touch()"
            @blur="sanitize($event, 'contactDetails')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="patent"
            :items="patents"
            label="Patents available"
            menu-props="auto, overflowY"
            item-text="patent"
            item-value="patent"
            return-object
            @change="$v.patent.$touch()"
            @blur="$v.patent.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="sdk"
            :items="sdks"
            label="SDK/API available"
            menu-props="auto, overflowY"
            item-text="sdk"
            item-value="sdk"
            return-object
            @change="$v.sdk.$touch()"
            @blur="$v.sdk.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="existing_partnership"
            :items="existing_partnerships"
            label="Existing Partnerships/Exclusivity (non-VC's)"
            menu-props="auto, overflowY"
            item-text="existing_partnership"
            item-value="existing_partnership"
            :error-messages="existing_partnership_Errors"
            return-object
            @change="$v.existing_partnership.$touch()"
            @blur="$v.existing_partnership.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
            v-model="businessModel"
            :items="businessModels"
            label="Business Model"
            menu-props="auto, overflowY"
            item-text="businessModel"
            item-value="businessModel"
            return-object
            @change="$v.businessModel.$touch()"
            @blur="$v.businessModel.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="website"
            label="Website"
            :rules="rules.website"
            :counter="200"
            @input="$v.website.$touch()"
            @blur="$v.website.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-combobox
            v-model="Tags"
            :items="tagsSuggestions"
            label="Tags (separate each tag clicking Enter)"
            multiple
            chips
          ></v-combobox>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-layout row wrap>
            <!--<v-flex xs5>
                          <v-autocomplete
                                  v-model="telephonePrefix.prefix"
                                  :items="telephonePrefixArray"
                                  label="Prefix"
                                  item-text="toShow"
                                  item-value="prefix"
                                  return-object
                          />
                        </v-flex><-->
            <v-flex xs12>
              <v-text-field
                v-model="mobilePhone"
                label="Mobile Phone"
                :rules="rules.mobilePhone"
                :counter="100"
                @input="$v.mobilePhone.$touch()"
                @blur="sanitize($event, 'mobilePhone')"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="contactLinks"
            label="Contact Links"
            :rules="rules.contactLinks"
            :counter="200"
            @input="$v.contactLinks.$touch()"
            @blur="$v.contactLinks.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="contactAddress"
            label="Contact Address"
            :counter="200"
            :rules="rules.contactAddress"
            @input="$v.contactAddress.$touch()"
            @blur="sanitize($event, 'contactAddress')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="logo"
            label="Logo"
            :counter="200"
            :rules="rules.logo"
            @input="$v.logo.$touch()"
            @blur="$v.logo.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="crunchbaseLink"
            label="Crunchbase link"
            :counter="200"
            :rules="rules.crunchbaseLink"
            @input="$v.crunchbaseLink.$touch()"
            @blur="$v.crunchbaseLink.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="fundingsAmount"
            label="Fundings Amount"
            :counter="200"
            :rules="rules.fundingsAmount"
            @input="$v.fundingsAmount.$touch()"
            @blur="sanitize($event, 'fundingAmount')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="fundingsDate"
            label="Fundings Date"
            :rules="rules.fundingsDate"
            :counter="100"
            @input="$v.fundingsDate.$touch()"
            @blur="sanitize($event, 'fundingsDate')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="fundingsInvestors"
            label="Fundings Investors"
            :counter="200"
            :rules="rules.fundingsInvestors"
            @input="$v.fundingsInvestors.$touch()"
            @blur="sanitize($event, 'fundingsInvestors')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="Valuations"
            label="Valuation"
            :counter="500"
            :rules="rules.Valuation"
            @input="$v.Valuation.$touch()"
            @blur="sanitize($event, 'Valuation')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="Competitors"
            label="Competitors"
            :counter="500"
            :rules="rules.Competitors"
            @input="$v.Competitors.$touch()"
            @blur="sanitize($event, 'Competitors')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="foundation"
            label="Foundation"
            :rules="rules.foundation"
            :counter="100"
            @input="$v.foundation.$touch()"
            @blur="sanitize($event, 'foundation')"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="numberEmployees"
            label="Number Employees"
            type="number"
            min="0"
            step="1"
            @input="$v.numberEmployees.$touch()"
            @blur="sanitize($event, 'numberEmployees')"
          />
        </v-flex>

        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="urlVideo"
            label="URL Video"
            :rules="rules.urlVideo"
            :counter="500"
            @input="$v.urlVideo.$touch()"
            @blur="$v.urlVideo.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
            v-model="dateAdded"
            label="Last Modification Date (month)"
            readonly
            v-on="on"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout align-center row spacer>
        <v-flex xs2 sm1 md1>
          <v-avatar>
            <img :src="require('@/assets/img/settings/flags/en.png')" />
          </v-avatar>
        </v-flex>
        <v-flex xs10 sm5 md5 class="pa-3">
          <v-textarea
            v-model="englishDescription"
            auto-grow
            box
            :counter="2500"
            :rules="rules.description"
            name="englishDescription"
            label="English idea description"
            border-radius="20px"
            value=""
            rows="2"
            @blur="sanitize($event, 'englishDescription')"
          />
        </v-flex>
        <v-flex xs2 sm1 md1 v-if="country === 'Italy'">
          <v-avatar>
            <img :src="require('@/assets/img/settings/flags/it.png')" />
          </v-avatar>
        </v-flex>
        <v-flex xs10 sm5 md5 v-if="country === 'Italy'">
          <v-textarea
            v-model="italianDescription"
            auto-grow
            box
            :counter="2500"
            :rules="rules.description"
            name="italianDescription"
            label="Italian idea description"
            border-radius="20px"
            value=""
            rows="2"
            @blur="sanitize($event, 'italianDescription')"
          />
        </v-flex>
      </v-layout>

      <v-btn round dark color="green" @click="submit"> Submit changes </v-btn>
    </v-form>

    <v-dialog v-model="status" max-width="450">
      <v-card v-if="error">
        <v-card-title class="headline error white--text"
          >Process failed</v-card-title
        >
        <v-card-text>Your proposal is not valid!</v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-title class="headline success white--text"
          >Submission successfully completed</v-card-title
        >
        <v-card-text>Your update proposal will soon be evaluated!</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UrlsService from "@/helpers/UrlsService.js";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import RouterService from "@/helpers/RouterService";
import AlertService from "@/helpers/AlertService";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import {
  email,
  required,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import countryList from "country-list";

Vue.use(VueSanitize);

export default {
  name: "StartuModificationForm",
  components: {},
  props: {},
  mixins: [validationMixin],
  validations: {
    name: { required, minLength: minLength(3), maxLength: maxLength(50) },
    country: { required },
    city: { required },
    region: { required },
    contactName: { required },
    contactDetails: { email, required },
    logo: { required },
    fundingsDate: { required },
    area: { required },
    verticalSolution: { required },
    ideaState: { required },
    patent: { required },
    sdk: { required },
    existing_partnership: {},
    businessModel: { required },
    website: {},
    contactAddress: {},
    fundingsInvestors: {},
    fundingsAmount: {},
    foundation: {},
    numberEmployees: {},
    contactLinks: {},
    tags: {},
    mobilePhone: {},
    crunchbaseLink: {},
    urlVideo: {},
  },

  data() {
    return {
      error: false,
      status: false,
      startup: {},
      token: "",
      rules: {
        required: (value) => !!value || "Required",
        name: [
          (value) => !!value || "Required",
          (v) =>
            v.length <= 50 || "Startup name must be less than 50 characters",
          (v) => v.length >= 3 || "Startup name must be at least 3 characters",
        ],
        city: [
          (v) => v.length <= 100 || "City must be less than 100 characters",
          (v) => v == "",
        ],
        description: [
          (v) =>
            v.length <= 2500 || "Description must be less than 2500 characters",
        ],
        contactName: [
          (v) =>
            v.length <= 100 || "Contact name must be less than 100 characters",
          (value) => {
            const pattern = /^[a-zA-Z0-9_.,;-]+( *[a-zA-Z0-9_.,;-]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "No special characters are allowed"
            );
          },
        ],
        email: [
          (value) => !!value || "Required",
          (value) => {
            //const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            const pattern =
              /^(\s?[^£$%&+=*'<>()[\]\\,;:\s@"]+@[^£$%&+=*'<>()[\]\\,;:\s@"]+\.[^£$%&+=*'<>()[\]\\,;:\s@"]+\s?[,;\/])*(\s?[^£$%&+=*'<>()[\]\\,;:\s@"]+@[^£$%&+=*'<>()[\]\\,;:\s@"]+\.[^£$%&+=*'<>()[\]\\,;:\s@"]+)$/g;
            return value === "" || pattern.test(value) || "Invalid e-mail";
          },
          (v) =>
            v.length <= 500 || "Email address must be less than 500 characters",
          (v) => v.length >= 5 || "Email addres must be at least 5 characters",
        ],
        contactDetails: [
          (v) =>
            v.length <= 100 ||
            "Contact Details must be less than 100 characters",
        ],
        englishDescription: [
          (v) =>
            v.length <= 2500 ||
            "English description must be less than 2500 characters",
        ],
        italianDescription: [
          (v) =>
            v.length <= 2500 ||
            "Italian description must be less than 100 characters",
        ],
        website: [
          (value) => {
            const pattern =
              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "Invalid website"
            );
          },
          (v) => v.length <= 200 || "Website must be less than 200 characters",
        ],
        mobilePhone: [
          (value) => {
            const pattern =
              /^([+]*[(]?[+]?[0-9]{1,4}[)]?[-\s.0-9]*)( ?[,;] ?[+]*[(]?[+]?[0-9]{1,4}[)]?[-\s.0-9]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "Invalid mobile phone numbers"
            );
          },
          (v) =>
            v.length <= 100 || "Mobile phone must be less than 100 characters",
        ],
        contactLinks: [
          (value) => {
            const pattern =
              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "Invalid contact links"
            );
          },
          (v) =>
            v.length <= 200 || "Contact links must be less than 200 characters",
        ],
        fundingsDate: [
          (v) =>
            v.length <= 100 ||
            "Funding investors must be less than 100 characters",
          (value) => {
            const pattern = /^[a-zA-Z0-9_.,;\/-]+( *[a-zA-Z0-9_.,;\/-]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "No special characters are allowed"
            );
          },
        ],
        foundation: [
          (v) =>
            v.length <= 100 || "Foundation must be less than 100 characters",
          (value) => {
            const pattern = /^[a-zA-Z0-9_.,;\/-]+( *[a-zA-Z0-9_.,;\/-]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "No special characters are allowed"
            );
          },
        ],
        contactAddress: [
          (v) =>
            v.length <= 200 ||
            "Contact address must be less than 200 characters",
          (value) => {
            const pattern = /^[a-zA-Z0-9_.,;-]+( *[a-zA-Z0-9_.,;-]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "No special characters are allowed"
            );
          },
        ],
        urlVideo: [
          (value) => {
            const pattern =
              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "Invalid URL video"
            );
          },
          (v) =>
            v.length <= 500 || "URL video must be less than 500 characters",
        ],
        logo: [
          (value) => {
            const pattern =
              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "Invalid logo url"
            );
          },
          (v) =>
            v.length <= 200 || "Logo link must be less than 200 characters",
        ],
        crunchbaseLink: [
          (value) => {
            const pattern =
              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "Invalid crunchbase url"
            );
          },
          (v) =>
            v.length <= 200 ||
            "Crunchbase url must be less than 200 characters",
        ],
        fundingsInvestors: [
          (v) =>
            v.length <= 200 ||
            "Funding investors must be less than 200 characters",
          (value) => {
            const pattern =
              /^[a-zA-Z0-9_.$£€,\s-]+( *[a-zA-Z0-9_.$£€,\s-]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "No special characters are allowed"
            );
          },
        ],
        fundingsAmount: [
          (v) =>
            v.length <= 200 ||
            "Funding amount must be less than 200 characters",
          (value) => {
            const pattern =
              /^[a-zA-Z0-9_.$£€,\s-]+( *[a-zA-Z0-9_.$£€,\s-]+)*$/gm;
            return (
              value === "" ||
              value === "-" ||
              pattern.test(value) ||
              "No special characters are allowed"
            );
          },
        ],
      },

      telephonePrefix: "",
      telephonePrefixArray: [],
      name: "",
      country: "",
      countries: [],
      tagsSuggestions: [],
      Tags: [],
      mobilePhone: "",
      contactLinks: "",
      contactAddress: "",
      fundingsAmount: "0.0",
      logo: "",
      crunchbaseLink: "",
      fundingsDate: "",
      fundingsInvestors: "",
      foundation: "",
      numberEmployees: "",
      regions: [
        "Abruzzo",
        "Basilicata",
        "Calabria",
        "Campania",
        "Emilia Romagna",
        "Friuli Venezia Giulia",
        "Lazio",
        "Liguria",
        "Lombardia",
        "Marche",
        "Molise",
        "Piemonte",
        "Puglia",
        "Sardegna",
        "Sicilia",
        "Toscana",
        "Trentino Alto Adige",
        "Umbria",
        "Valle d'Aosta",
        "Veneto",
      ],
      region: "",
      city: "",
      contactName: "",
      contactDetails: "",
      verticalSolution: "",
      area: "",
      ideaState: "",
      ideaStates: [
        "Idea",
        "Prototype/beta version",
        /*"Ready",*/ "Product",
        "On the market",
        "First customers",
      ],
      areas: {},
      patent: "",
      patents: ["Yes", "No", "Pending"],
      sdk: "",
      sdks: ["Yes", "No"],
      existing_partnership: "",
      existing_partnerships: ["Yes", "No"],
      businessModel: "",
      businessModels: ["B2B", "B2B:B2C", "B2C"],
      website: "",
      englishDescription: "",
      italianDescription: "",
      dateAdded: new Date().toISOString().substr(0, 7),
      urlVideo: "",
    };
  },
  created() {
    this.token = this.$route.query.token;
    this.countries = countryList.getNames().sort();
    this.getTagsSuggestion(), this.getStartupInfo();
  },
  methods: {
    convertParameter(param) {
      param = param.toLowerCase();
      if (param === "yes") return "y";
      else if (param === "no") return "n";
      else if (param === "pending") return "pending";
      else return "-";
    },
    inverseConvertParameter(param) {
      param = param.toLowerCase();
      if (param === "y") return "Yes";
      else if (param === "n") return "No";
      else if (param === "pending") return "Pending";
      else return "";
    },
    sanitize(event, variableName) {
      event.preventDefault();
      this[variableName] = this.$sanitize(event.target.value);
    },
    formValidate() {
      this.$v.$touch();
      return this.$refs.form.validate();
    },
    getTagsSuggestion() {
      let requestUrl = {
        url: UrlsService.getTagsSuggestion,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "",
          elasticSearchRequest: {
            pageSize: 1000,
            pageNumber: 0,
          },
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List Tags Suggestion",
        error: "Error get suggestion...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(
        requestObject,
        messages,
        options
      ).then((responseSuccess) => {
        this.tagsSuggestions = [];
        let responseSearch = responseSuccess.response.searchResults;
        if (responseSearch != undefined) {
          for (let i = 0; i < responseSearch.length; i++) {
            if (
              responseSearch[i]["tags"] != undefined &&
              responseSearch[i]["approved"] == 1
            ) {
              let tags = responseSearch[i]["tags"];
              for (let j = 0; j < tags.length; j++) {
                if (
                  !this.tagsSuggestions.includes(tags[j]) &&
                  tags[j] != "None"
                ) {
                  this.tagsSuggestions.push(tags[j]);
                }
              }
            }
          }
        }
        let responseArea = responseSuccess.response.areas;
        if (responseArea !== undefined) {
          for (let i = 0; i < responseArea.length; i++) {
            this.areas[responseArea[i].area] = responseArea[i].verticals;
          }
        }
      });
    },
    submit() {
      this.$v.$touch();
      if (this.$refs.form.validate()) {
        this.startup["Area"] = this.area.trim();
        this.startup["Name"] = this.name.trim();
        this.startup["Country"] = this.country.trim();
        this.startup["Region / city"] =
          this.country === "Italy" ? this.region.trim() : this.city.trim();
        this.startup["Contact name"] = this.contactName.trim();
        this.startup["Contact details"] = this.contactDetails.trim();
        this.startup["Idea description-EN"] = this.englishDescription.trim();
        this.startup["Idea description-IT"] = this.italianDescription.trim();
        this.startup["Vertical solution (if any)"] =
          this.verticalSolution.trim();
        this.startup["Idea state"] = this.ideaState.trim();
        this.startup["Patent"] = this.convertParameter(this.patent);
        this.startup["SDK/API"] = this.convertParameter(this.sdk);
        (this.startup["Existing Partnerships/Exclusivity (non-VC's)"] =
          this.convertParameter(this.existing_partnership)),
          (this.startup["Business model"] = this.businessModel.trim());
        this.startup["Website"] =
          !this.website.startsWith("http") && this.website !== ""
            ? "http://" + this.website.trim()
            : this.website.trim();
        this.startup["Tags"] = this.Tags;
        this.startup["Mobile phone"] = this.mobilePhone.trim();
        this.startup["Contact links"] =
          !this.contactLinks.startsWith("http") && this.contactLinks !== ""
            ? "http://" + this.contactLinks.trim()
            : this.contactLinks.trim();
        this.startup["Contact address"] = this.contactAddress.trim();
        this.startup["Fundings amount"] = this.fundingsAmount.trim();
        this.startup["Logo"] =
          !this.logo.startsWith("http") && this.logo !== ""
            ? "http://" + this.logo.trim()
            : this.logo.trim();
        this.startup["Crunchbase link"] =
          !this.crunchbaseLink.startsWith("http") && this.crunchbaseLink !== ""
            ? "http://" + this.crunchbaseLink.trim()
            : this.crunchbaseLink.trim();
        this.startup["Fundings date"] = this.fundingsDate.trim();
        this.startup["Fundings investors"] = this.fundingsInvestors.trim();
        this.startup["Valuation"] = this.Valuation.trim();
        this.startup["Competitors"] = this.Competitors.trim();
        this.startup["Foundation"] = this.foundation.trim();
        this.startup["Date Added"] = this.dateAdded;
        this.startup["NumberEmployees"] = this.numberEmployees.trim();
        this.startup["UrlVideo"] =
          !this.urlVideo.startsWith("http") && this.urlVideo !== ""
            ? "http://" + this.urlVideo.trim()
            : this.urlVideo.trim();

        for (let key in this.startup) {
          if (this.startup[key] === "") {
            this.startup[key] = null;
          }
        }
        let requestUrl = {
          url: UrlsService.updateStartupAuth,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          token: this.token,
          startup: this.startup,
        };
        let requestObject = {
          type: "public",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
          },
        };
        let messages = {
          title: "Update startup",
          loading: "Sending the update request",
          error: "Server Error",
        };
        let options = {
          loadingType: "fullscreen",
          timeout: TimeService.secondsToMillis(0),
        };
        APILoaderDecoratorService.setLoader(
          requestObject,
          messages,
          options
        ).then((responseSuccess) => {
          let response = responseSuccess;
          if (
            response.response !== null &&
            response.responseStatus.code === 200
          ) {
            this.status = true;
            this.error = false;
          } else {
            this.status = true;
            this.error = true;
          }
        });
      }
    },
    getStartupInfo() {
      let requestUrl = {
        url: UrlsService.getStartupPublic,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        token: this.token,
      };
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Get Startup information",
        loading: "Waiting for information...",
        error: "Cannot retrieve startup information...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(
        requestObject,
        messages,
        options
      ).then((responseSuccess) => {
        this.startup = responseSuccess.response.startups[0];
        for (let key in this.startup) {
          if (this.startup[key] === "None") {
            this.startup[key] = "";
          }
        }
        this.name = this.startup["Name"];
        this.$emit("updateName", this.name);
        this.$emit("updateApproved", this.startup["approved"]);
        this.country = this.startup["Country"];
        this.city =
          this.country === "Italy" ? "" : this.startup["Region / city"];
        this.region =
          this.country === "Italy" ? this.startup["Region / city"] : "";
        this.contactName = this.startup["Contact name"];
        this.contactDetails = this.startup["Contact details"];
        this.verticalSolution = this.startup["Vertical solution (if any)"];
        this.area = this.startup["Area"];
        this.ideaState = this.startup["Idea state"];
        this.patent = this.inverseConvertParameter(this.startup["Patent"]);
        this.sdk = this.inverseConvertParameter(this.startup["SDK/API"]);
        this.existing_partnership = this.inverseConvertParameter(
          this.startup["Existing Partnerships/Exclusivity (non-VC's)"]
        );
        this.businessModel = this.startup["Business model"];
        this.website = this.startup["Website"];
        this.englishDescription = this.startup["Idea description-EN"];
        this.italianDescription = this.startup["Idea description-IT"];
        this.Tags = this.startup["Tags"];
        this.mobilePhone = this.startup["Mobile phone"];
        this.contactLinks = this.startup["Contact links"];
        this.contactAddress = this.startup["Contact address"];
        this.fundingsAmount = this.startup["Fundings amount"];
        this.logo = this.startup["Logo"];
        this.crunchbaseLink = this.startup["Crunchbase link"];
        this.fundingsDate = this.startup["Fundings date"];
        this.fundingsInvestors = this.startup["Fundings investors"];
        this.Valuation = this.startup["Valuation"];
        this.Competitors = this.startup["Competitors"];
        this.foundation = this.startup["Foundation"];
        this.numberEmployees = this.startup["NumberEmployees"];
        this.urlVideo = this.startup["UrlVideo"];
      });
    },
  },
};
</script>

<style lang="scss"></style>
